import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Field } from "redux-form";
import { renderField } from "../../../utils/renderField";
import { getBranches } from "../../../actions/cardControls.actions";
import Show from "../../../utils/show.component";

const LocateBranchComponent = (props) => {
  const [zipCode, setZipCode] = useState("");
  const [zipError, setZipError] = useState("");
  
  const search = (e) => {
    setZipError("");

    e.preventDefault();
    if (zipCode && zipCode.length === 5) {
      props.getBranches(zipCode);
    } else {
      setZipError("Please enter a 5 digit zip code");
    }
  }

  const getDirections = (branch) => {
    return `https://www.google.com/maps/dir/?api=1&destination=Lake+Trust+${branch.Address}+${branch.City}&origin=${zipCode}`;
  }

  useEffect(() => {
    if (props.cardControls.branches === null) {
      setZipError("We're having trouble processing your request. Please check your zip code and try again.");
    }
  }, [props.cardControls])

  return (
    <React.Fragment>
      <div className="mb-3">
        <Field
          label="Enter your zip code to see branches near you"
          name="zipCode"
          component={renderField}
          type="text"
          onChange={(e) => setZipCode(e.target.value)}
        />
        <Show condition={zipError}>
          <div className="error-message">{zipError}</div>
        </Show>
      </div>
      <button className="primary mb-3" onClick={search}>Find a Branch</button>
      <div className="branch-container mb-5">
        {props.cardControls.branches && props.cardControls.branches.map(branch => (
          <div className="branch-box">
            <div className="branch-heading">{branch.BranchName}</div>
            <div>{branch.Address}</div>
            <div>{branch.City}, {branch.State} {branch.Zip}</div>
            <div>{branch.Duration}</div>
            <div>{branch.Distance} {branch.Distance === 1 ? "mile" : "miles"}</div>
            <a href={getDirections(branch)} target="_blank">Get Directions &gt;</a>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};

const mapDispatchToProps = {
  getBranches
};

const LocateBranch = connect(null, mapDispatchToProps)(LocateBranchComponent);

export default LocateBranch;



// WEBPACK FOOTER //
// ./src/components/card-controls/misc/locate-branch.component.js